// extracted by mini-css-extract-plugin
export var loaderWrapper = "gamification-list-view-module--loader-wrapper--E2FIP";